import { Component, ViewChild} from "@angular/core";
import { SlickDialogComponent } from "@slick-components";
import { CustomerDuplicateDialogResult, ICustomerDuplicateCheckModel, ICustomerModel } from "@models";

@Component({
	selector: "conflicting-customers-dialog",
	templateUrl: "./conflicting-customers-dialog.component.html",
	styleUrls: ["./conflicting-customers-dialog.component.scss"]
})

export class ConflictingCustomerDialogComponent {
	@ViewChild("dialogRef", { static: true }) dialogRef: SlickDialogComponent;

	newCustomer: ICustomerModel;
	duplicateChecks: ICustomerDuplicateCheckModel[] = [];

	resolve: (value: CustomerDuplicateDialogResult) => void;
	private activeDialogPromise: Promise<CustomerDuplicateDialogResult>;

	constructor() {
	}

	async showSuggestionDialog(newCustomer: ICustomerModel, duplicateChecks: ICustomerDuplicateCheckModel[]): Promise<CustomerDuplicateDialogResult> {
		if (this.activeDialogPromise)
			return this.activeDialogPromise;

		this.activeDialogPromise = new Promise<CustomerDuplicateDialogResult>((resolve) => {
			this.resolve = (value: CustomerDuplicateDialogResult) => {
				this.activeDialogPromise = null;
				resolve(value);
			};
			this.newCustomer = newCustomer;
			this.duplicateChecks = duplicateChecks;
			this.dialogRef.showDialog();
		});

		return this.activeDialogPromise;
	}

	useExistingCustomer(customerId: number) {
		this.resolve(customerId);
		this.dialogRef.hideDialog();
	}

	keepEnteringNewCustomer() {
		this.resolve('add');
		this.dialogRef.hideDialog();
	}

	cancel() {
		if (!this.resolve)
			return;

		this.resolve('cancel');
		this.dialogRef.hideDialog();
	}

	get headlineMessage(): string {
		const count = this.duplicateChecks?.length ?? 0;
		const customerWord = count === 1 ? "customer" : "customers";
		return `We found ${count} similar ${customerWord} that already exist. Select one below or continue creating a new customer.`;
	}

	getFullAddress(customer?: ICustomerModel): string {
		if (!customer)
			return '';

		const parts: string[] = [];

		if (customer.address1?.trim())
			parts.push(customer.address1.trim());

		const cityState = [customer.city?.trim(), customer.state?.trim()].filter(Boolean).join(", ");
		const cityStateZip = [cityState, customer.zipcode?.trim()].filter(Boolean).join(" ");

		if (cityStateZip)
			parts.push(cityStateZip);

		return parts.join(", ");
	}

	getDisplayName(customer?: ICustomerModel): string {
		if (!customer)
			return '';

		if (customer.companyName)
			return customer.companyName;

		return this.getPersonName(customer);
	}

	getPersonName(customer?: ICustomerModel): string {
		if (!customer)
			return '';

		return `${customer.firstName || ''} ${customer.lastName || ''}`.trim();
	}

	showPersonName(customer?: ICustomerModel): boolean {
		if (!customer)
			return false;

		return !!customer.companyName && !!this.getPersonName(customer);
	}
}
